export const IconPlus = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
      <g clipPath='url(#clip0_914_13946)'>
        <path
          d='M16.5625 5.22498C17.1458 5.55665 17.5042 6.17748 17.5 6.84832V12.9183C17.5 13.5925 17.1308 14.2142 16.535 14.5417L10.91 18.1C10.6311 18.2531 10.3181 18.3334 10 18.3334C9.68186 18.3334 9.36887 18.2531 9.09 18.1L3.465 14.5417C3.17347 14.3823 2.9301 14.1476 2.76034 13.862C2.59058 13.5765 2.50067 13.2505 2.5 12.9183V6.84748C2.5 6.17332 2.86917 5.55248 3.465 5.22498L9.09 1.90832C9.37711 1.75001 9.69964 1.66699 10.0275 1.66699C10.3554 1.66699 10.6779 1.75001 10.965 1.90832L16.59 5.22498H16.5625Z'
          stroke='black'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M7.5 10H12.5'
          stroke='black'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M10 7.5V12.5'
          stroke='black'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_914_13946'>
          <rect width='20' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};
